import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ShoppingBag, X } from 'lucide-react';
const purchases = [{
  name: 'María L.',
  city: 'Buenos Aires',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 3 min'
}, {
  name: 'Carlos R.',
  city: 'Córdoba',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 5 min'
}, {
  name: 'Luciana F.',
  city: 'Rosario',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 8 min'
}, {
  name: 'Fernando D.',
  city: 'Mendoza',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 12 min'
}, {
  name: 'Valentina S.',
  city: 'La Plata',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 15 min'
}, {
  name: 'Diego M.',
  city: 'Tucumán',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 18 min'
}, {
  name: 'Camila B.',
  city: 'Mar del Plata',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 22 min'
}, {
  name: 'Martín G.',
  city: 'Salta',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 25 min'
}, {
  name: 'Sofía T.',
  city: 'San Juan',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 28 min'
}, {
  name: 'Nicolás P.',
  city: 'Neuquén',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 31 min'
}, {
  name: 'Florencia A.',
  city: 'Santa Fe',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 35 min'
}, {
  name: 'Joaquín V.',
  city: 'Bahía Blanca',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 40 min'
}, {
  name: 'Paula C.',
  city: 'Resistencia',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 44 min'
}, {
  name: 'Agustín H.',
  city: 'Posadas',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 48 min'
}, {
  name: 'Rocío E.',
  city: 'San Luis',
  product: 'MegaPack Sistema Soberano',
  time: 'hace 52 min'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    // Initial delay before first popup
    const initialDelay = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    return () => clearTimeout(initialDelay);
  }, []);
  useEffect(() => {
    if (isDismissed) return;
    const interval = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        setIsVisible(true);
      }, 1000);
    }, 7000);
    return () => clearInterval(interval);
  }, [isDismissed]);
  // Auto-hide each notification after 5s
  useEffect(() => {
    if (!isVisible || isDismissed) return;
    const hideTimer = setTimeout(() => {
      setIsVisible(false);
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [isVisible, isDismissed]);
  if (isDismissed) return null;
  const purchase = purchases[currentIndex];
  return <div className="fixed bottom-4 left-4 z-50 max-w-sm" data-id="element-244">
      <AnimatePresence data-id="element-245">
        {isVisible && <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.95
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 25
      }} className="bg-dark-card border border-dark-border rounded-xl p-4 shadow-[0_4px_30px_rgba(0,0,0,0.5)] flex items-start gap-3" data-id="element-246">
            <div className="shrink-0 w-10 h-10 rounded-full bg-gold/20 flex items-center justify-center" data-id="element-247">
              <ShoppingBag className="w-5 h-5 text-gold" data-id="element-248" />
            </div>

            <div className="flex-grow min-w-0" data-id="element-249">
              <p className="text-white text-sm font-semibold leading-tight" data-id="element-250">
                {purchase.name}{' '}
                <span className="text-gray-400 font-normal" data-id="element-251">de</span>{' '}
                <span className="text-gold-light" data-id="element-252">{purchase.city}</span>
              </p>
              <p className="text-gray-400 text-xs mt-1" data-id="element-253">
                Adquirió el{' '}
                <span className="text-gray-300" data-id="element-254">{purchase.product}</span>
              </p>
              <p className="text-gray-500 text-xs mt-1" data-id="element-255">{purchase.time}</p>
            </div>

            <button onClick={() => setIsDismissed(true)} className="shrink-0 text-gray-600 hover:text-gray-400 transition-colors p-0.5" aria-label="Cerrar notificación" data-id="element-256">
              <X className="w-4 h-4" data-id="element-257" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}